import { Ruthie } from '../components/Ruthie';

export default function RuthiePage() {
  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border">
        <h1 className="text-2xl font-bold text-foreground">Data Architect</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Design your semantic layer through natural conversation with Ruthie.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Ruthie showHistory={true} />
      </div>
    </div>
  );
}
